const CUSTOM_ACTIVE_CLASS = 'm-active';
let observer = null;
let inactiveClass = '';
let activeClass = '';

function filterClasses(classList) {
    // Assume that active star use only classes modifiers and that classes do not have __
    const classModifier = Array.from(classList).filter(cls => !cls.includes('__'));
    return classModifier[0];
}

function guessActiveClass(stars) {
    // If at least one star is active we could get active CSS class otherwise guess inactive
    const checkedStar = Array.from(stars).find(star => star.getAttribute('aria-checked') === 'true');

    if (checkedStar) {
        activeClass = filterClasses(checkedStar.classList);
    } else {
        inactiveClass = filterClasses(stars[0].classList);
    }
}

function fillStarsWithClasses(stars) {
    if (!activeClass) { return; }
    stars.forEach(star => {
        if (star.classList.contains(activeClass)) {
            star.parentElement.classList.add(CUSTOM_ACTIVE_CLASS);
        }
    });
}

function handleStarsMutation(mutationsList) {
    mutationsList.forEach(mutation => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const star = mutation.target;
            const changedClass = filterClasses(star.classList);

            if (!activeClass) { // Additionally guess active class on interaction
                if (changedClass !== inactiveClass) { // Assume that only 2 classes is possible on this elements
                    activeClass = changedClass;
                }
            }

            if (changedClass === activeClass) {
                star.parentElement.classList.add(CUSTOM_ACTIVE_CLASS); // set to parent to not trigger mutation
            } else if (changedClass === inactiveClass) {
                star.parentElement.classList.remove(CUSTOM_ACTIVE_CLASS);
            }
        }
    });
}

export function initRatingStarsObserver() {
    const stars = document.querySelectorAll('#bv-ips-step-0 > section:nth-of-type(1) [role="radio"]');
    guessActiveClass(stars);
    fillStarsWithClasses(stars); // in case when we go back to prev step we fill stars before interaction

    observer = new MutationObserver(handleStarsMutation);
    const config = {
        attributes: true,
        attributeFilter: ['class', 'aria-checked'],
        subtree: true
    };

    stars.forEach(star => observer.observe(star, config));
}

export function removeRatingStarsObserver() {
    observer.disconnect;
    observer = null;
}
